import { createModuleBuilder } from '@evidentid/dashboard-commons/app';
import { GatewayApiClient } from '@evidentid/gateway-api-client';
import { EntityPropertyChangedDetails, NotificationDetails } from '@evidentid/tprm-portal-lib/models/activity-history';

import ViewEntityPropertyChangedProcedure from '@/modules/entity-events/procedures/ViewEntityPropertyChangedProcedure.vue';
import ViewNotificationDetailProcedure from '@/modules/entity-events/procedures/ViewNotificationDetailProcedure.vue';

export const entityEventsModule = createModuleBuilder()
    .demandContext<{ gatewayClient: GatewayApiClient }>()
    .registerProcedures<{
    viewNotificationDetailProcedure: { details: NotificationDetails };
    viewEntityPropertyChangedProcedure: { changedPropertiesDisplayNames: EntityPropertyChangedDetails['changedPropertiesDisplayNames'] };
}>({
        viewNotificationDetailProcedure: ViewNotificationDetailProcedure,
        viewEntityPropertyChangedProcedure: ViewEntityPropertyChangedProcedure,
    })
    .end();
